import React, { useEffect, useState } from "react";
import axios from "axios";

function Baymaxs01e01() {
  const [pageMessage, setPageMessage] = useState(
    "Hello,I'mInBaymaxs01e01PageFa"
  );

  useEffect(() => {
    handleRedirect();

    window.location.href = "https://www.aparat.com/v/FxtTE";
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: pageMessage,
    });
  };

  return (
    <div className="d-flex w-100 h-100vh justify-content-center align-items-center">
      در حال انتقال به صفحه‌ی پخش انیمیشن بیمکس - قسمت اول ...
    </div>
  );
}

export default Baymaxs01e01;
